'use client';

import { CSSProperties } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { addBtnGrey, addBtnGrey2 } from '../UnderstandYourSleep/icons';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './DesktopRecoveryComponent.module.css';

// import { addBtnGrey } from '../UnderstandYourSleep/icons';

export const DesktopRecoveryComponent = ({
  className,
  handleDynamicRecovery,
  handleStress,
  handleSkinTemperature,
  handleHRVfactor,
}: {
  className?: string;
  handleDynamicRecovery?: any;
  handleStress?: any;
  handleSkinTemperature?: any;
  handleHRVfactor?: any;
}) => {
  const t = useTranslations('ring');
  return (
    <section
      className={className ? `${styles.root} ${className}` : styles.root}
      aria-labelledby="recovery-section-heading"
    >
      <div className="top">
        {/* <h2>The edge in your recovery game</h2>
          <p>
            Dynamic Recovery analyzes key physiological markers for a real-time
            Recovery Score. Understand how sleep, stress rhythm, skin
            temperature, and HRV affect your body&apos;s restoration. Improve
            recovery with power naps and breathwork techniques.
          </p> */}
        <h2 id="recovery-section-heading">
          {t('ring.bentoRecoverySection.head')}
        </h2>
        <p>{t('ring.bentoRecoverySection.subHead')}</p>
      </div>
      <div className="top-left">
        <div className="content">
          {/* <h4>dynamic recovery</h4>
            <h3>Track your recovery changes throughout the day</h3> */}
          <h4 id="dynamic-recovery-title">
            {t('ring.bentoRecoverySection.dynamicRecoveryCard.title')}
          </h4>
          <h3>{t('ring.bentoRecoverySection.dynamicRecoveryCard.subtitle')}</h3>
          <div
            className="img-container"
            role="img"
            aria-label={t('desktopRecoveryComponent.content.ariaLabel')}
          >
            <Image
              src={'web_v2/ring-buy/recovery/png/dynamicDesk.png'}
              fill
              alt=""
              className="dynamic-recovery-img"
              aria-hidden="true"
            />
          </div>
        </div>
        <button
          className="expand"
          onClick={handleDynamicRecovery}
          aria-label={t(
            'desktopRecoveryComponent.button.ariaLabel.learnMoreAbout',
          )}
          aria-describedby="dynamic-recovery-title"
        >
          {addBtnGrey2}
        </button>
      </div>
      <div className="top-right">
        <div className="content">
          {/* <h4>SKIN TEMPERATURE</h4>
            <h3>
              Early indicators <br /> with temperature <br /> metrics
            </h3> */}
          <h4 id="skin-temperature-title">
            {t('ring.bentoRecoverySection.skinTemperatureCard.title')}
          </h4>
          <h3>
            {t('ring.bentoRecoverySection.skinTemperatureCard.subtitleA')}{' '}
            <br />{' '}
            {t('ring.bentoRecoverySection.skinTemperatureCard.subtitleB')}{' '}
            <br />{' '}
            {t('ring.bentoRecoverySection.skinTemperatureCard.subtitleC')}
          </h3>
          <div
            className="img-container"
            role="img"
            aria-label={t('desktopRecoveryComponent.content.ariaLabel2')}
          >
            <Image
              src={'web_v2/ring-buy/recovery/svg/skinTempRing.png'}
              fill
              alt=""
              className="temperature-img"
              aria-hidden="true"
            />
          </div>
        </div>
        <button
          className="expand dark-hover"
          onClick={handleSkinTemperature}
          aria-label={t(
            'desktopRecoveryComponent.button.ariaLabel.learnMoreAbout2',
          )}
          aria-describedby="skin-temperature-title"
        >
          {addBtnGrey}
        </button>
      </div>
      <div className="bottom-left">
        {' '}
        <div className="content">
          {/* <h4>HRV factor</h4>
            <h3>
              Continuous HRV <br /> monitoring
            </h3> */}
          <h4 id="hrv-factor-title">
            {t('ring.bentoRecoverySection.hrvCard.title')}
          </h4>
          <h3>
            {t('ring.bentoRecoverySection.hrvCard.subtitleA')} <br />{' '}
            {t('ring.bentoRecoverySection.hrvCard.subtitleB')}
          </h3>
        </div>
        <div
          className="img-container"
          role="img"
          aria-label={t(
            'desktopRecoveryComponent.content.hrvFactorVisualization',
          )}
        >
          <Image
            src={'web_v2/ring-buy/recovery/svg/hrvFactor.svg'}
            fill
            alt=""
            className="hrv-factor"
            aria-hidden="true"
          />
        </div>
        <div className="mask-container" />
        <button
          className="expand dark-hover"
          onClick={handleHRVfactor}
          aria-label={t(
            'desktopRecoveryComponent.button.ariaLabel.learnMoreAbout3',
          )}
          aria-describedby="hrv-factor-title"
        >
          {addBtnGrey}
        </button>
      </div>
      <div
        className="bottom-right"
        style={
          {
            '--bottom-right-bg': `url(${getCompressedAssetUrl(
              '/web_v2/ring-buy/sleep/png/tinted.png',
            )})`,
          } as CSSProperties
        }
      >
        <div className="content">
          {/* <h4>impact of stress</h4>
            <h3>
              Regulate Stress with your <br /> body’s natural rhythm
            </h3> */}
          <h4 id="stress-title">
            {t('ring.bentoRecoverySection.stressCard.title')}
          </h4>
          <h3>
            {t('ring.bentoRecoverySection.stressCard.subtitleA')} <br />{' '}
            {t('ring.bentoRecoverySection.stressCard.subtitleB')}
          </h3>
          <div
            className="img-container"
            role="img"
            aria-label={t('desktopRecoveryComponent.content.ariaLabel3')}
          >
            <Image
              src={'web_v2/ring-buy/recovery/svg/assetStress.svg'}
              fill
              alt=""
              className="stress-img"
              aria-hidden="true"
            />
          </div>
        </div>
        <button
          className="expand"
          onClick={handleStress}
          aria-label={t(
            'desktopRecoveryComponent.button.ariaLabel.learnMoreAbout4',
          )}
          aria-describedby="stress-title"
        >
          {addBtnGrey2}
        </button>
      </div>
    </section>
  );
};
